import { DragDropContext } from "react-beautiful-dnd";
import { Provider } from "react-redux";
import { TitleComponent } from "../title/TitleComponent";
import { ArgumentList } from "../arguments/ArgumentList";
import { Seesaw } from "../arguments/Seesaw";
import { store } from "../../app/store";
import "./export.css"

export function ExportedView(props: { width: number, height: number }) {
    const { width, height } = props;

    return <div className="App export-view light" style={{
        width, height,
        backgroundColor: "white",
        ...{ "--argument-width": `${width * 0.125}px` }
    }}>
        <Provider store={store}>
            <DragDropContext onDragEnd={() => { }} >
                <TitleComponent field="title" />

                <div className="unsorted-list">
                    <ArgumentList listKey='unsorted' />
                </div>

                <Seesaw />

                <div className="bottom-row">
                    <TitleComponent field="pro" />
                    <TitleComponent field="contra" />
                </div>

                <footer style={{ opacity: 0.5 }}>
                    <span>Erstellt mit der Argumentationswippe</span>
                    <span>·</span>
                    <a href="https://argumentationswippe.de">argumentationswippe.de</a>
                </footer>
            </DragDropContext>
        </Provider>
    </div >
}
